import { render, staticRenderFns } from "./AvaliacoesTab.vue?vue&type=template&id=5cf567cd"
import script from "./AvaliacoesTab.vue?vue&type=script&lang=js"
export * from "./AvaliacoesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports